import { useLayoutEffect } from 'react';
import { css } from '@emotion/react';
import { MultiStep, useMultiStepControl } from '@frontend/design-system';
import { CareCreditEnrollmentProvider } from './care-credit-enrollment-multi-step/context/care-credit-enrollment.provider';
import {
  CareCreditEnrollmentMultiStepBaseProps,
  CareCreditEnrollmentMultiSteps,
} from './care-credit-enrollment-multi-step/enrollment-multi-step.types';
import { Step1SelectProcessMethod } from './care-credit-enrollment-multi-step/steps/step1-select-process-method';
import { Step2ApplicationForm } from './care-credit-enrollment-multi-step/steps/step2-application-form';
import { Step3ApplicantPrequalified } from './care-credit-enrollment-multi-step/steps/step3-applicant-prequalified';
import { Step4ApplicationConfirm } from './care-credit-enrollment-multi-step/steps/step4-application-confirm';
import { Step5ApplicationResult } from './care-credit-enrollment-multi-step/steps/step5-application-result';
import { getEnrollmentSteps } from './care-credit-enrollment-multi-step/utils/get-enrollment-steps';

const PARENT_TOPBAR_HEIGHT = 64;

const styles = {
  multiStepOverrides: css`
    .multi-step__body-wrapper {
      background: transparent;
    }

    .step {
      max-height: calc(100vh - ${48 + PARENT_TOPBAR_HEIGHT}px);
      min-height: ${500 - PARENT_TOPBAR_HEIGHT}px;
      gap: 0;
      margin-bottom: 0;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
    .step__body {
      margin-bottom: 0;
    }
  `,
};

export type CareCreditEnrollmentMultiStepProps = CareCreditEnrollmentMultiStepBaseProps & {
  className?: string;
};

export const CareCreditEnrollmentMultiStep = ({
  className,
  multiStepProps,
  trackingId = 'cc-enrollment-generic',
  ...props
}: CareCreditEnrollmentMultiStepProps) => {
  const initialActiveStep: CareCreditEnrollmentMultiSteps = 'select-process-method';

  const multiStepControl = useMultiStepControl({
    initialActiveStep,
    stepper: { show: false },
    isInModal: true,
    trackingId,
    ...multiStepProps,
  });

  useLayoutEffect(() => {
    multiStepControl.setSteps(getEnrollmentSteps());
  }, []);

  return (
    <CareCreditEnrollmentProvider {...props} multiStepControl={multiStepControl}>
      <MultiStep.Root
        {...multiStepControl}
        trackingId={trackingId || multiStepControl.trackingId}
        className={className}
        css={styles.multiStepOverrides}
      >
        <Step1SelectProcessMethod />
        <Step2ApplicationForm />
        <Step3ApplicantPrequalified />
        <Step4ApplicationConfirm />
        <Step5ApplicationResult />
      </MultiStep.Root>
    </CareCreditEnrollmentProvider>
  );
};
